module.exports = __webpack_public_path__ + "img/tips.477e9949.png";